//This is the white bar that goes the width of the screen and let's you select a current league
import React, { useState, useEffect } from 'react'
import Card from './Card'
import './SelectLeague.css'
import { useNavigate } from 'react-router-dom'

const SelectLeagueForScoringLeaders = () => {
	const [isLoading, setIsLoading] = useState(false)
	const [loadedLeagues, setLoadedLeagues] = useState()
	const [leaguesNoDuplicates, setLeaguesNoDuplicates] = useState()
	const [error, setError] = useState()
	let selectedLeague

	console.log('inside SelectLeagueForScoringLeaders')

	//Call backend to get all the current leagues for our dropdown
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/leagues/current',
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				console.log('responseData: ' + JSON.stringify(responseData))

				setLoadedLeagues(responseData.currentLeagues)
				setLeaguesNoDuplicates(responseData.currentLeagues)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [setLoadedLeagues, setLeaguesNoDuplicates])

	let leagueArray, leaguesNoDuplicatesArray

	//
	//
	//
	if (leaguesNoDuplicates && !isLoading) {
		leaguesNoDuplicatesArray = []
		leaguesNoDuplicates.forEach((league) => {
			const leagueDisplay = league.leagueName + ' - ' + league.year
			leaguesNoDuplicatesArray.push(leagueDisplay)
		})
	}

	let navigate = useNavigate()

	const handleChange = (e) => {
		if (e.target.value === '*Previous Tournaments*') {
			navigate('/league/previousLeagues')
		} else if (e.target.value !== 'Search for Tournament Leaders...') {
			e.preventDefault()
			const selectedValue = e.target.value
			//console.log(selectedValue)
			selectedLeague = leaguesNoDuplicates[selectedValue]
			const leagueId = selectedLeague._id
			navigate(`/league/scoring/${leagueId}`)
		}
	}

	return (
		<React.Fragment>
			<div className='searchbyleagueorvenue'>
				<div className='row'>
					<div className='LTVinstructions'>Find a Tournament: </div>
				</div>
				{!isLoading && leaguesNoDuplicates && (
					<div className='row'>
						<div className='col'></div>
						<div className='col-sm'>
							<form className='dropdownForm' style={{ textAlign: 'center' }}>
								<select
									className='scheduleselectornonadmin'
									onChange={handleChange}
								>
									<option defaultValue>Search for Tournament Leaders...</option>
									{leaguesNoDuplicatesArray.map((league, i) => (
										<option value={i} key={i}>
											{league}
										</option>
									))}
									<option style={{ background: '#fee89a' }}>
										*Previous Tournaments*
									</option>
								</select>
							</form>
						</div>
						<div className='col'></div>
					</div>
				)}
			</div>
		</React.Fragment>
	)
}

export default SelectLeagueForScoringLeaders

{
	/* <React.Fragment>
			<Card>
				{!isLoading && leaguesNoDuplicates && (
					<form className='form-control-lg'>
						<select
							className='selector my-1 mr-sm-2 selectLeagueDropdown'
							onChange={handleChange}
						>
							<option defaultValue>Select Tournament....</option>
							{leaguesNoDuplicatesArray.map((league, i) => (
								<option value={i} key={i}>
									{league}
								</option>
							))}
							<option style={{ background: '#bd9122' }}>
								VIEW PREVIOUS TOURNAMENTS
							</option>
						</select>
					</form>
				)}
			</Card>
		</React.Fragment> */
}
